module.exports = __webpack_public_path__ + "img/yitongguo.e2b3f656.svg";